import {
  GRID_SIZE_MD,
  GRID_SIZE_LG,
  GRID_SIZE_XL,
  GRID_SIZE_DEFAULT
} from '../../constants'

export const SITE_CONTAINER_MAX_WIDTH = 1200
export const FOOTER_NAVBAR_HEIGHT = '188px'
export const FOOTER_NAVBAR_MESSAGE_HEIGHT = '235px'
export const FOOTER_HEIGHT = '92px'

const getMaxWidth = viewport => {
  switch (viewport) {
    case 'md':
      return GRID_SIZE_MD
    case 'lg':
      return GRID_SIZE_LG
    case 'xl':
      return GRID_SIZE_XL
    default:
      return GRID_SIZE_DEFAULT
  }
}

const removeFromHeight = (freeDeliveryMessage, isNavbarFixed) => {
  if (isNavbarFixed) {
    return FOOTER_HEIGHT
  }
  if (freeDeliveryMessage) {
    return FOOTER_NAVBAR_MESSAGE_HEIGHT
  }

  return FOOTER_NAVBAR_HEIGHT
}

export default {
  container: (
    isFullWidth: boolean,
    freeDeliveryMessage: boolean,
    isNavbarFixed: boolean,
    hasNoPading: boolean,
    viewport: string,
    isAtHomePage: boolean
  ) => {
    return isFullWidth
      ? {
        width: '100%'
      }
      : {
        width: isAtHomePage
          ? getMaxWidth(viewport)
          : SITE_CONTAINER_MAX_WIDTH,
        margin: '0 auto',
        boxSizing: 'border-box',
        padding: hasNoPading ? 0 : '0px 16px 36px',
        minHeight: `calc(100vh - ${removeFromHeight(
          freeDeliveryMessage,
          isNavbarFixed
        )})`
      }
  }
}
